import React from 'react'
import { TimePickerField, DatePickerField } from './utils'

const Validity = ({ required, readOnlyField, generateStateMappers }) => {
  return (
    <>
      <div className="validFrom">
        <DatePickerField
          placeholder="startDate"
          label="validFrom"
          readOnlyField={readOnlyField}
          generateStateMappers={generateStateMappers}
          required={required}
        />
        <TimePickerField
          label="startTime"
          readOnlyField={readOnlyField}
          generateStateMappers={generateStateMappers}
          required={required}
        />
      </div>
      <div className="validTo">
        <DatePickerField
          placeholder="endDate"
          label="validTo"
          readOnlyField={readOnlyField}
          generateStateMappers={generateStateMappers}
          required={required}
        />
        <TimePickerField
          label="endTime"
          readOnlyField={readOnlyField}
          generateStateMappers={generateStateMappers}
          required={required}
        />
      </div>
    </>
  )
}
export default Validity
